import { Pipe, PipeTransform } from '@angular/core';
import { environment } from 'src/environments/environment';

@Pipe({
  name: 'currencyMask',
  standalone: false,
})
export class CurrencyMaskPipe implements PipeTransform {
  transform(
    value: number | string | null | undefined,
    digits?: number,
  ): string {
    if (value === null || value === undefined) {
      return '';
    }

    const num = Number(value);

    if (isNaN(num)) {
      return '';
    }

    const options: Intl.NumberFormatOptions = {};
    const defaultDigits = environment.defaultDecimalDigits ?? 2;
    const requestedDigits =
      digits !== undefined &&
      digits !== null &&
      !isNaN(digits) &&
      digits >= 0 &&
      digits <= 20
        ? digits
        : defaultDigits;

    options.minimumFractionDigits = requestedDigits;
    options.maximumFractionDigits = requestedDigits;

    return num.toLocaleString('en-US', options);
  }
}
